'use strict';
(function () {
  angular.module('pentaApp').factory('reservationStats.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/reservationStats', {}, {});
  }

})();